<template>
    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4" :style="{'display': showStorage ? 'block': 'none'}">
        <div class="card h-100">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-12 col-md-4 mb-4">
                        <h5 class="card-title">Disk Space</h5>
                    </div>
                    <div class="col-sm-12 col-md-5 mb-5">
                        <select class="form-control-sm mt-2 w-100" v-model="currentDomain" @change="load">
                            <option :value="index" v-for="(domain, index) in domains" :key="index">{{domain.domain}}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-12 col-md-3 mb-3">
                        <button class="btn btn-primary btn-sm" @click="refreshDiskSpace" :disabled="timeBlockUpdateSpace">
                            <i :class="{'fa fa-refresh': true, 'fa-spin': spinner}"></i>  Refresh
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body pb-0">
                <div :class="{row: true}">
                    <div class="col-sm-12 col-md-6 mb-6">
                        <div class="d-block">
                            <div id="chart"></div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mb-6">
                        <div class="col-sm-12" v-for="(item, index) in this.diskInfo" :key="index">
                            <hr v-if="index == 'total'">
                            <div class="col-mb d-block">
                                <strong class="d-block" :style="{color: item.data[0].color}">{{item.title}}:
                                    {{item.data[0].humanSize}}{{item.data[0].value}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as d3 from "d3"
    import refreshToken from "../../../mixins/refreshTokenMixin"
    import swal from "sweetalert2"
    import moment from "moment"
    import adminLogs from "../../../mixins/adminLogs";

    export default {
        name: "DiskSpace",
        mixins: [refreshToken, adminLogs],
        data: function () {
            return {
                domains: [],
                chartDonuts: '',
                currentDomain: 0,
                spinner: false,
                showStorage: false,
                timeBlockUpdateSpace: localStorage.getItem('block_update') ? localStorage.getItem('block_update'): false,
                diskInfo: {
                    "disk": {
                        "title": "File Disk Usage",
                        "data": [
                            {
                                color: "#5B7CFB",
                                size: 0,
                                value: ''
                            },
                            {
                                size: 0,
                                color: "#ddd",
                                value: ''
                            }
                        ],
                        "width": 190,
                        "height": 190,
                        "thickness": 25,
                        "left": 35,
                        "top": 35
                    },
                    "database": {
                        "title": "Database Disk Usage",
                        "data": [
                            {
                                color: "#ef8157",
                                size: 0,
                                value: ''
                            },
                            {
                                size: 0,
                                color: "#ddd",
                                value: ''
                            }
                        ],
                        "width": 120,
                        "height": 120,
                        "thickness": 25,
                        "left": 70,
                        "top": 70
                    },
                    "total": {
                        "title": "Total Disk Usage",
                        "data": [
                            {
                                color: "#6bd098",
                                size: 0,
                                value: ''
                            },
                            {
                                size: 0,
                                color: "#ddd",
                                value: ''
                            }
                        ],
                        "width": 260,
                        "height": 260,
                        "thickness": 25,
                        "left": 0,
                        "top": 0
                    }
                }
            }
        },
        computed: {
            userToken() {
                return this.$store.getters.getUserToken;
            },
            accounts() {
                if(this.$store.getters["hosting/accounts"] === undefined){
                    return [];
                }
                return this.$store.getters["hosting/accounts"];
            },
            user() {
                return this.$store.getters.user;
            },
            plans() {
                return this.$store.getters["plan/list"];
            }
        },
        watch: {
          accounts () {
            this.showStorage = false
            this.mapData()
          }
        },
        created(){
            this.checkBlockUpdateSpace();
        },
        mounted() {
          if (this.accounts.length) {
            this.mapData()
          }
        },
        methods: {
            mapData () {
              this.domains = []
              this.accounts.map((account) => {
                if(account.fullDiskSpace !== undefined && Object.keys(account.fullDiskSpace).length){
                  this.domains.push({
                    domain: 'All',
                    diskSpace: account.fullDiskSpace,
                    planName: account.planName
                  });
                  this.domains.push({
                    domain: account.primary.domain,
                    diskSpace: account.primary.diskSpace,
                    planName: account.planName
                  });
                  if (account.primary.staging.domain !== undefined && account.primary.staging.domain) {
                    this.domains.push({
                      domain: account.primary.staging.domain,
                      diskSpace: account.primary.staging.diskSpace,
                      planName: account.planName
                    });
                  }
                  account.addon.map((addon) => {
                    this.domains.push({
                      domain: addon.domain,
                      diskSpace: addon.diskSpace,
                      planName: account.planName
                    });
                    if (addon.staging.domain !== undefined && addon.staging.domain) {
                      this.domains.push({
                        domain: addon.staging.domain,
                        diskSpace: addon.staging.diskSpace,
                        planName: account.planName
                      });
                    }
                  })
                  this.showStorage = true;
                }
              });

              if(this.showStorage) {
                if (!this.chartDonuts) {
                  this.chartDonuts = d3.select("#chart")
                      .append('svg')
                      .attr('class', 'pie')
                      .attr('width', 260)
                      .attr('height', 260);
                }
                this.load();
              }
            },
            checkBlockUpdateSpace(){
                let block = setInterval(()=>{
                    let blockUpdateTime = localStorage.getItem('block_update_time');
                    if((moment().unix() > blockUpdateTime)){
                        this.timeBlockUpdateSpace = false;
                        localStorage.setItem('block_update', false);
                        clearInterval(block);
                    }
                }, 1000);
            },
            load() {
                try {
                    let domain = this.domains[this.currentDomain];
                    for (let index in this.diskInfo) {
                        if(domain.diskSpace.length) {

                            /*let diskSpaceFull = domain.diskSpace[2].size;
                            if (domain.diskSpace[2].value == 'G') {
                                diskSpaceFull *= 1024;
                            }*/

                            domain.diskSpace.map((item) => {
                                if (this.diskInfo[index].title == item.name) {
                                    let size = 1;
                                    if(item.value == 'G'){
                                        size *= 1024;
                                    }
                                    this.diskInfo[index].data[0].humanSize = parseFloat(item.size) ;
                                    this.diskInfo[index].data[0].size = parseFloat(item.size) * size;

                                    let plan = this.plans.filter((item) => item.name == domain.planName);
                                    let maxStorageSize = plan[0].maxStorageSize;
                                    if(this.accounts[0].maxStorageSize !== undefined){
                                        maxStorageSize = this.accounts[0].maxStorageSize;
                                    }
                                    let maxStorageSizeMb = maxStorageSize * 1024;

                                    /*if(diskSpaceFull >= (maxStorageSizeMb * 0.95) && domain.planName == "WPO Starter"){
                                        maxStorageSizeMb =  maxStorageSizeMb + (5 * 1024);
                                    }*/

                                    if (plan.length) {
                                        this.diskInfo[index].data[1].size = maxStorageSizeMb - this.diskInfo[index].data[0].size;
                                    }
                                    this.diskInfo[index].data[0].value = item.value;
                                }
                            });
                            this.drawDiskSpaceDonuts(this.chartDonuts, this.diskInfo[index]);
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            drawDiskSpaceDonuts: (chartDonuts, data) => {
                //https://bl.ocks.org/mattkohl/9f3a283813cf0226311f41595582c9eb
                let radius = Math.min(data.width, data.height) / 2;

                let g = chartDonuts.append('g')
                    .attr('transform', 'translate(' + (data.width / 2 + data.left) + ',' + (data.height / 2 + data.top) + ')');

                let arc = d3.arc()
                    .innerRadius(radius - data.thickness)
                    .outerRadius(radius);

                let pie = d3.pie()
                    .value(function (d) {
                        return d.size;
                    })
                    .sort(null);

                g.selectAll('path')
                    .data(pie(data.data))
                    .enter()
                    .append("g")
                    .append('path')
                    .attr('d', arc)
                    .attr('fill', (d) => d.data.color)
                    .each(function (d, i) {
                        this._current = i;
                    });
            },
            refreshDiskSpace() {
                if(!this.timeBlockUpdateSpace) {
                    this.spinner = true;
                    this.$http.post('disk/space', {
                        user_id: this.user.uid,
                        grant_type: "token",
                        token: this.userToken
                    })
                        .then(() => {
                          this.addLog({
                            message: 'Disk space has been updated for all accounts.',
                            level:  "success"
                          })
                            this.$store.dispatch("hosting/fetchAccounts")
                            swal({
                                title: "Success!",
                                html: "Disk space updated",
                                type: "success"
                            })
                            localStorage.setItem('block_update_time', moment().add(1, 'minutes').unix());
                            this.timeBlockUpdateSpace = true;
                            localStorage.setItem('block_update', true);
                        })
                        .catch((err) => {
                            this.addLog({
                              message: 'Error in updating disk space for all accounts. Message: ' + err.response.data.message,
                              level:  "error"
                            })
                            if (err.response.status == 401 && this.countRequests < 1) {
                                this.refreshToken()
                            }
                            swal({
                                title: "Something went wrong!",
                                html: "Error update disk space. Message: " + err.response.data.data.message,
                                type: "error",
                                confirmButtonText: "Try Again!",
                                confirmButtonColor: "#EE8057"
                            });
                        }).finally(() => {
                        this.spinner = false;
                    })
                }
            }
        }
    }
</script>
